/* global PdfSignExtension */

import React, { useContext, useState } from "react";
import { InfoBarContext } from "../../../../common/info";
import { cleanJoin } from "../../../../utils/stringUtil";
import { RequestSubmissionContext } from "../RequestSubmissionContext";
import { useTranslation } from "react-i18next";
import { MessageContext } from "../../../../common/message";
import { getAccessToken } from "../../../../common/authorization/AuthorizeService";
import { checkForHttpErrors } from "../upload/DocumentUploadButton";

function Sign({ disabled, label, display, id, uid }) {
  const { state, dispatch } = useContext(RequestSubmissionContext);
  const message = useContext(MessageContext);
  const { t } = useTranslation();
  const [isStampedOrSigned, setIsStampedOrSigned] = useState(false);

  const closeAutomatically = () => {
    message.toggle({});
  };

  const signPdf = async (pdf) => {
    if (pdf) {
      var uint8Array;
      pdf.arrayBuffer().then((buffer) => {
        uint8Array = new Uint8Array(buffer);

        if (typeof PdfSignExtension !== "undefined") {
          PdfSignExtension.Setup({ languageId: "eng" });
          PdfSignExtension.SignPdf(
            {
              pdfContent: uint8Array,
              signatureType: 1,
              onlyValidCertificate: false,
            },
            async function (data) {
              const file = new Blob([data.buffer], { type: "application/pdf" });
              const formData = new FormData();
              formData.append("file", file, state.pdfForm.url.split("/").pop());
              const request = new XMLHttpRequest();
              request.onload = checkForHttpErrors(request);
              request.open("POST", `${process.env.REACT_APP_GATEWAY_URL}/upload`);

              //identity

              let token = await getAccessToken();

              request.setRequestHeader("Request-Origin", "portal");
              request.setRequestHeader("Authorization", `Bearer ${token}`);

              request.send(formData);
              request.onreadystatechange = function () {
                if (this.readyState === 4) {
                  dispatch({
                    type: "sign",
                    payload: request.response.substring(9, request.response.length - 2),
                  });
                  setIsStampedOrSigned(true);
                  message.toggle({
                    title: t("modalMessage.titleInfo"),
                    content: "Dokument je uspješno potpisan. Možete poslati zahtjev.",
                    hideNo: true,
                    yesLabel: t("modalMessage.okLabel"),
                    onYes: () => message.toggle({}),
                  });
                }
              };
              return file;
            },
            function (data) {
              alert(data.ErrorStacktrace);
            },
            function () {},
            function () {}
          );
        }
      });
    }
  };

  async function previewAndSignPost() {
    fetch(
      `${process.env.REACT_APP_GATEWAY_URL}/requests/${state.id}/submissions/${state.uid}/preview`,
      {
        method: "POST",
        body: JSON.stringify(state),
        headers: {
          "Content-Type": "application/json",
          "Request-Origin": "portal",
          Authorization: "Bearer " + (await getAccessToken()),
        },
        mode: "cors",
        credentials: "include",
      }
    )
      .then((response) => response.blob())
      .then((pdf) => signPdf(pdf))
      .then(closeAutomatically);
  }

  const sign = () => {
    dispatch({ type: "unblock" });
    message.toggle({
      title: "Potpisivanje PDF-a",
      content:
        "Ukoliko potpišete PDF, više ga nećete moći uređivati kasnije. Jeste li sigurni da želite potpisati PDF?",
      onNo: () => message.toggle({}),
      onYes: () => {
        message.toggle({});
        message.toggle({
          title: "",
          content: t("requests.overview.submitted.wait.label"),
          hideNo: true,
          hideYes: true,
          hideX: true,
          isWait: true,
        });
        previewAndSignPost();
      },
    });
  };

  return display ? (
    <button
      disabled={disabled}
      className={cleanJoin(
        "button",
        "pdf-form-action-button",
        "no-focus-outline",
        "has-border-green-1",
        !disabled
          ? "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
          : ""
      )}
      onClick={sign}
    >
      {label}
    </button>
  ) : null;
}

export default Sign;
